import numeral from 'numeral';

// ----------------------------------------------------------------------

export function fNumber(number) {
  return numeral(number).format();
}

export function fCurrency(number) {
  const format = number ? numeral(number).format('$0,0.00') : '';

  return result(format, '.00');
}

export function fCurrencyEuro(number) {
  const format = number ? numeral(number).format('0,0.00') : '';

  let newFormat = result(format, '.00');
  newFormat = newFormat.replace(',', '@');
  newFormat = newFormat.replace('.', ',');
  newFormat = newFormat.replace('@', '.')
  newFormat = `${newFormat} €`;
  return newFormat;
}

export function fCurrencyEuroWith00(number) {
  const format = number ? numeral(number).format('0,0.00') : '';

  let newFormat = result(format, '');
  newFormat = newFormat.replace(',', '@');
  newFormat = newFormat.replace('.', ',');
  newFormat = newFormat.replace('@', '.')
  newFormat = `${newFormat} €`;
  return newFormat;
}

export function fPercent(number) {
  const format = number ? numeral(Number(number) / 100).format('0.00%') : '';

  return result(format, '.00');
}

export function fPercentEuro(number) {
  let format = number ? numeral(Number(number) / 100).format('0,0.00%') : '';
  format = format.replace(',', '@');
  format = format.replace('.', ',');
  format = format.replace('@', '.');
  return result(format, ',00');
}

export function fPercentEuroOne(number) {
  let format = number ? numeral(Number(number) / 100).format('0,0.0%') : '';
  format = format.replace(',', '@');
  format = format.replace('.', ',');
  format = format.replace('@', '.');
  return result(format, ',0');
}

export function fEuroNumber(number) {
  let format = number ? numeral(number).format('0,0.00') : '';
  format = format.replace(',', '@');
  format = format.replace('.', ',');
  format = format.replace('@', '.');
  return result(format, ',00');
}

export function fShortenNumber(number) {
  if (typeof number === 'string') return number;
  const format = number ? numeral(number).format('0.00a') : '';
  return result(format, '.00');
}

export function fData(number) {
  const format = number ? numeral(number).format('0.0 b') : '';

  return result(format, '.0');
}

function result(format, key = '.00') {
  const isInteger = format.includes(key);

  return isInteger ? format.replace(key, '') : format;
}
